import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// Smooth scroll global (Lenis) synchronisé avec le ScrollTrigger de la hero.
// Désactivé si prefers-reduced-motion ; comportement natif conservé sur tactile.
export default function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname === '/sur-mesure' || pathname === '/personalisation') return undefined;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;

    gsap.registerPlugin(ScrollTrigger);

    const lenis = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
      syncTouch: false,
    });
    window.lenis = lenis;

    lenis.on('scroll', ScrollTrigger.update);
    const raf = (time) => lenis.raf(time * 1000);
    gsap.ticker.add(raf);
    gsap.ticker.lagSmoothing(0);

    return () => {
      gsap.ticker.remove(raf);
      lenis.destroy();
      if (window.lenis === lenis) delete window.lenis;
    };
  }, [pathname]);

  return null;
}
